module.exports = __webpack_public_path__ + "assets/img/240301.fcb812e9.svg";